import { isNull, isUndefined, trim } from 'lodash'

import { PROFILE_OTHER_MIN } from './consts'

export const isStringSingleEmoji = (str: string) =>
  /^(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])$/.test(
    str
  )
export const headString = (str: string | undefined, len: number) => str?.substring(0, len) ?? ''

export const isNumeric = (x: number | string | null | undefined) => !isNull(x) && !isUndefined(x) && +x === +x

const URL_SCHEME_REGEX = /(?:https?:\/\/|www\.)/i
const URL_TLDS = 'com|net|org|io|co|me|app|dev|gg|tv|ly|link|xyz|info|biz|site|shop|club|live|page|ee|fm'
// bare domains: the TLD has to be all one case, so a missing space after a period ("travel.Me and my
// dog") isn't mistaken for a link, while a real domain ("Linktr.ee", "LINKTR.EE") still is. a
// mixed-case TLD ("Linktr.Ee") gets through — that's the price of not flagging ordinary typos.
// regex heuristic — also misses obfuscation ("dot com", unicode lookalikes); tighten if spam gets through
const BARE_DOMAIN_REGEX = new RegExp(`\\b[A-Za-z0-9][A-Za-z0-9-]*\\.(?:${URL_TLDS}|${URL_TLDS.toUpperCase()})\\b`)

export const hasUrl = (str: string | null | undefined) =>
  URL_SCHEME_REGEX.test(str ?? '') || BARE_DOMAIN_REGEX.test(str ?? '')

/**
 * Validates the free text behind a "Something Else" option. The text is always OPTIONAL — picking
 * the option without typing anything is valid — but once the user types, it has to be a real
 * answer rather than a stray character or a run of spaces.
 *
 * @returns a user-facing message naming `label`, or null when the value is acceptable
 */
export const getOtherTextError = (label: string, value: string | null | undefined, max: number) => {
  const trimmed = trim(value ?? '')

  if (trimmed.length === 0) {
    return null
  }

  if (trimmed.length < PROFILE_OTHER_MIN) {
    return `${label} must be at least ${PROFILE_OTHER_MIN} characters, or left blank`
  }

  if (trimmed.length > max) {
    return `${label} cannot exceed ${max} characters`
  }

  return hasUrl(trimmed) ? `${label} cannot contain links` : null
}
